/**
 * Scroll Watcher Module
 * Adds 'scrolled-down' class to body when scrolling past threshold
 */

export default function initScrollWatcher() {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const scrollWatcher = () => {
        if (lastScrollY > 10) {
            document.body.classList.add('scrolled-down');
        } else {
            document.body.classList.remove('scrolled-down');
        }
        ticking = false;
    };
    
    window.addEventListener('scroll', () => {
        lastScrollY = window.scrollY;
        if (!ticking) {
            window.requestAnimationFrame(() => {
                scrollWatcher();
            });
            ticking = true;
        }
    });
    
    // Initial check
    scrollWatcher();
}

